import React, { useState, useEffect } from 'react';
import {
  Box,
  Theme,
  TooltipProps,
  Typography,
  makeStyles,
  createStyles
} from '@material-ui/core';
import CustomCard from './CustomCard';
import Footer from './Footer';
import Header from './Header';
import { getUser } from './user';

interface IFrontPage1Props {
  readonly cardDetailsList: {
    onStart: () => void;
    label: string;
    imageUri: string;
    tooltip: string;
    tooltipPosition?: TooltipProps['placement'];
    sealed?: boolean;
  }[];
  readonly children?: any;
  readonly topImageUri: string;
  readonly title?: string;
  readonly subtitle?: string;
  readonly footerLogoUrl?: string;
  readonly headerLogoUrl?: string;
  readonly onClickLogin: () => void;
  readonly centeredCards?: boolean;
}
const useStyles = makeStyles(({ spacing, breakpoints, palette }: Theme) =>
  createStyles({
    root: {
      // backgroundColor: "rgba(65, 64, 66,0.75)",
      width: '100%',
      [breakpoints.only('xs')]: {
        minHeight: '50vh',
        marginBottom: '5%'
      },
      [breakpoints.only('sm')]: {
        minHeight: '30vh',
        marginBottom: '4%'
      },
      [breakpoints.only('md')]: {
        minHeight: '50vh',
        marginBottom: '2%'
      },
      [breakpoints.only('lg')]: {
        minHeight: '35vh',
        marginBottom: '1%'
      },
      [breakpoints.only('xl')]: {
        minHeight: '35vh',
        marginBottom: '1%'
      },

      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat'
    },
    title: {
      color: palette.common.white,
      fontWeight: 700,
      paddingTop: spacing(4)
    },
    subtitle: {
      color: palette.common.white
    }
  })
);
const FrontPage1: React.FunctionComponent<IFrontPage1Props> = ({
  cardDetailsList,
  children,
  title,
  subtitle,
  topImageUri,
  footerLogoUrl,
  centeredCards,
  onClickLogin,
  headerLogoUrl
}) => {
  const classes = useStyles();
  const body = document.body;
  const html = document.documentElement;
  const user = getUser();
  const [height, setHeight] = useState<number>(
    Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    )
  );

  useEffect(() => {
    setHeight(
      Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      )
    );
  }, [
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  ]);
  return (
    <Box
      position="relative"
      width="1"
      height={height}
      display="flex"
      alignItems="center"
      flexDirection="column"
      bgcolor="#f7f7f7"
    >
      <React.Fragment>
        <Header
          onClickLogin={onClickLogin}
          headerLogoUrl={headerLogoUrl}
          user={user || undefined}
        />
      </React.Fragment>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        className={classes.root}
        style={{ backgroundImage: `url(${topImageUri})` }}
        width="inherit"
      >
        {title && (
          <Typography variant="h3" className={classes.title}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography className={classes.subtitle} variant="h3">
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box
        display="flex"
        justifyContent={centeredCards ? 'center' : 'flex-start'}
        flexWrap="wrap"
        width={{ xs: '100vw', sm: '50vw', md: '50vw', lg: '54vw', xl: '45vw' }}
      >
        {cardDetailsList.map((card, index) => (
          <Box
            key={index}
            flexBasis={{
              xs: '100%',
              sm: '50%',
              md: '50%',
              lg: '25%',
              xl: '25%'
            }}
          >
            <CustomCard
              onStart={card.onStart}
              imageUri={card.imageUri}
              label={card.label}
              tooltip={card.tooltip}
              tooltipPosition={card.tooltipPosition}
              sealed={card.sealed}
            />
          </Box>
        ))}
      </Box>
      {children}
      <Footer logoUrl={footerLogoUrl} />
    </Box>
  );
};

export default FrontPage1;
